import { Armchair, ChevronsUpDown, MessageSquareText, Repeat2, ClipboardPlus, Stethoscope, Phone, Send, EllipsisVertical, } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import MessageModal from '../Modal/MessageModal';
import BulkMessageSendModal from '../Modal/BulkMessageSendModal';
import PatientSingleViewModal from '../Modal/PatientSingleViewModal';
import { all_insurance_options, calculateAgeFromDOB, can_visit, exchangeDate, notify } from '../../helpers';
import LetterModal from '../Modal/LetterModal';
import CreateOrderModal from '../Modal/CreateOrderModal';
import CallNoteModal from '../Modal/CallNoteModal';
import CallNoteCallModal from '../Modal/CallNoteCallModal';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
const maleAvatar = './images/avatar.png';
const femaleAvatar = './images/female.png';
const otherAvatar = './images/other.png';

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function AverateRevenuePerEncounterDataTable(props) {
  const {
    tableData = [],
    handleCheckboxChange = () => {},
    handleSelectAll = () => {},
    selectAll = false,
    checkedIds = [],
    setCheckedIds = () => {},
    checkSelected = false,
    messageTemplate = [],
    reloadData = () => {},
    reloadDataFilter = {},
    account_id,
    location_id,
    dataLoading,
    setDataLoading = () => {},
    smsLimit,
    setSmsLimit = () => {},
    globalCheckedIds,
    setGlobalCheckedIds,
    selectedPatientData,
    setSelectedPatientData = () => {},
    setLetterLimit = () => {},
    handleAddToWaitingRoom = () => {},
    handleReferralNavigation = () => {},
    user_id,
    waitingRoomProviders = [],
    previousScrollPosition = 0,
    setPreviousScrollPosition = () => {}
  } = props;

  const [insuranceOptions] = useState(all_insurance_options());
  const [activePatientViewModal, setActivePatientViewModal] = useState(false);
  const [activeModal, setActiveModal] = useState(false);  
  const [patientData, setPatientData] = useState({});
  const [orderBy, setOrderBy] = useState();
  const [viewStatusOptions, setViewStatusOptions] = useState({});
  const [activeLetterModal, setactiveLetterModal] = useState(false);
  const [activeCreateOrderModal, setActiveOrderModal] = useState(false);
  const [activeCallNoteModal, setActiveCallNoteModal] = useState(false);
  const [activeCallNoteCallModal, setActiveCallNoteCallModal] = useState(false);
  const [callNoteCallType, setCallNoteCallType] = useState('');
  const [callId, setCallId] = useState(null);
  const [outreachOpen, setOutreachOpen] = useState(false);
  const [startSchedular, setStartSchedular] = useState(false);
  const [showButtonCount, setShowButtonCount] = useState(1);
  const [viewWaitingProviderOptions, setViewWaitingProviderOptions] = useState({});
  const userProviders = waitingRoomProviders;
  const [previousCallScrollPosition, setPreviousCallScrollPosition] = useState(0);

  useEffect(() => {
    if (can_visit('waiting_room') && can_visit('waiting_room_create') && !can_visit('ehr_veradigm')) {
      setShowButtonCount(1);
    } else {
      setShowButtonCount(2);
    }
  }, []);

  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    reloadData(filter_merge);
    setDataLoading(true);
  };
 
  const handleSendMessageModal = (data) => {
    setPatientData(data)
    setActiveModal(!activeModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const handleLetterModal = (data) => {
    setPatientData(data)
    setactiveLetterModal(!activeLetterModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const handleCallNoteModal = (data) => {
    setPatientData(data)
    setActiveCallNoteModal(!activeCallNoteModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const handleCreateOrderModal = (data) => {
    setPatientData(data)
    setActiveOrderModal(!activeCreateOrderModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }
  
  const handlePatientViewModal = (data) => {
    setPatientData(data);
    setActivePatientViewModal(!activePatientViewModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }

  const handleOutsideClick = (event) => {
    if (!event.target.closest(".dropdown-container")) {
      setViewStatusOptions({});
    }
    if (!event.target.closest(".dropdown-waiting-container")) {
      setViewWaitingProviderOptions({});
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const handleDropdownClick = (index) => {
    setViewStatusOptions((prev) => {
      const newViewStatusOptions = {};
      newViewStatusOptions[index] = !prev[index];
      return newViewStatusOptions;
    });
  };

  const handleWaitingDropdownClick = (index) => {
    if(userProviders?.length === 0) {
      notify("error", "Provider not found", 2);
      return;
    }
    setViewWaitingProviderOptions((prev) => {
      const newViewWaitingOptions = {};
      newViewWaitingOptions[index] = !prev[index];
      return newViewWaitingOptions;
    });
  };

  const removeSelection = () => {
    setSelectedPatientData([]);
    setCheckedIds([]);
    setGlobalCheckedIds(new Set());
  };

  const buttonArray = [
    { label: 'Add call note', icon: Phone, isButton: true, action: handleCallNoteModal },
    // { label: 'Add to waiting room', icon: Armchair, isButton: true, action: handleAddToWaitingRoom },
    // { label: 'Create AI chart', icon: ClipboardPlus, isButton: false, action: '/ai-charting/create' },
    { label: 'Create order', icon: Stethoscope, isButton: true, action: handleCreateOrderModal },
    { label: 'Refer patient', icon: Repeat2, isButton: true, action: handleReferralNavigation },
    { label: 'Send letter', icon: Send, isButton: true, action: handleLetterModal },
    { label: 'Send message', icon: MessageSquareText, isButton: true, action: handleSendMessageModal },
  ];
  const permissions = {
    showButton1: can_visit('_call_note'),
    // showButton2: can_visit('waiting_room') && can_visit('waiting_room_create'),
    // showButton2: can_visit('ai_charting') && can_visit('ai_charting_create'),
    showButton2: can_visit('imaging_orders') && can_visit('imaging_orders_create'),
    showButton3: can_visit('easy_referral') && can_visit('easy_referral_create'),
    showButton4: can_visit('letter') && can_visit('_send_letter'),
    showButton5: can_visit('_single_message'),
  };

  return (
    <>
      {(checkSelected && can_visit('_bulk_message')) && (
        <>
          <div className="docpro_data_table_btns">
            <BulkMessageSendModal
              // checkedIds={checkedIds}
              messageTemplate={messageTemplate}
              account_id={account_id}
              location_id={location_id}
              smsLimit={smsLimit}
              setSmsLimit={setSmsLimit}
              checkedIds={Array.from(globalCheckedIds)}
              setGlobalCheckedIds={setGlobalCheckedIds}
              selectedPatientData={selectedPatientData}
              setSelectedPatientData={setSelectedPatientData}
            />
            
            {checkedIds?.length > 0 && (
              <div className='docpro_filtered_badge' style={{ margin: 0 }}>
                <span><b>Selected Patients</b>: {checkedIds?.length}</span>
                <button
                  onClick={removeSelection}
                >
                  ✕
                </button>
              </div>
            )}
          </div>
        </>
      )}

      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0">
          <thead>
            <tr>
              <th style={{ width: "45px" }}>
                <div className="docpro_checkbox" style={{ top: "3px" }}>
                  <input
                    type="checkbox"
                    checked={tableData.length > 0 && tableData.every((row) => globalCheckedIds?.has(row?.id))}
                    onChange={handleSelectAll}
                    disabled={tableData.length === 0}
                  />
                  <label></label>
                </div>
              </th>
              {can_visit("_role_enterprise") && (
                <>
                  {/* <th 
                    onClick={() => {
                      handleOrderChange("account_name");
                    }}
                    className={orderBy === "account_name" ? "docpro_accent_color" : ""}
                  >
                    <div style={styles}>
                      Practice Name <ChevronsUpDown size={"12"} />
                    </div>
                  </th>
                  <th 
                    onClick={() => {
                      handleOrderChange("location_name");
                    }}
                    className={orderBy === "location_name" ? "docpro_accent_color" : ""}
                  >
                    <div style={styles}>
                      Location <ChevronsUpDown size={"12"} />
                    </div>
                  </th> */}
                  <th> Practice Name </th>
                  <th> Location </th>
                </>
              )}
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("last_name");
                  }}
                  className={
                    orderBy === "last_name" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Last Name <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("first_name");
                  }}
                  className={
                    orderBy === "first_name" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    First Name <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("date_of_birth");
                  }}
                  className={
                    orderBy === "date_of_birth" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Date of Birth <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("dob");
                }}
                className={orderBy === "dob" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Age <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("phone");
                  }}
                  className={orderBy === "phone" ? "docpro_accent_color" : ""}
                >
                  <div style={styles}>
                    Phone <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("insurance_name");
                }}
                className={
                  orderBy === "insurance_name" ? "docpro_accent_color" : ""
                }
              >
                <div style={styles}>
                  Insurance Name <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("encounters");
                }}
                className={
                  orderBy === "encounters" ? "docpro_accent_color" : ""
                }
              >
                <div style={styles}>
                  Total Visit <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("payments");
                }}
                className={orderBy === "payments" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Total Payment <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("average_revenue");
                }}
                className={
                  orderBy === "average_revenue" ? "docpro_accent_color" : ""
                }
              >
                <div style={styles}>
                  Average Payment <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className={`row_${item.id}`}>
                    <td style={{ width: "45px" }}>
                      <div className="docpro_checkbox" style={{ top: "3px" }}>
                        <input
                          type="checkbox"
                          checked={globalCheckedIds.has(item.id)}
                          onChange={() => handleCheckboxChange(item.id, item)}
                        />
                        <label></label>
                      </div>
                    </td>
                    {can_visit("_role_enterprise") && (
                      <>
                        <td onClick={() => handlePatientViewModal(item)}>
                          {item.accountName}
                        </td>
                        <td onClick={() => handlePatientViewModal(item)}>
                          {item.locationName}
                        </td>
                      </>
                    )}
                    <td className="bulk pointer" onClick={() => handlePatientViewModal(item)}>
                      <div className="flex items-center table_img">
                        <img src={item.sex === "M" ? maleAvatar : item.sex === "F" ? femaleAvatar : otherAvatar} alt="User" />
                        {item.lastName}
                      </div>
                    </td>
                    <td
                      className="bulk pointer"
                      onClick={() => handlePatientViewModal(item)}
                    >
                      {item.firstName}
                    </td>
                    <td className="pointer" onClick={() => handlePatientViewModal(item)}>
                      {exchangeDate(item.birthDate)}
                    </td>
                    <td onClick={() => handlePatientViewModal(item)}>
                      {calculateAgeFromDOB(item?.birthDate)}y
                    </td>
                    <td
                      className="bulk pointer"
                      onClick={() => handlePatientViewModal(item)}
                    >
                      {item.phoneNumber}
                    </td>
                    <td className="pointer" onClick={() => handlePatientViewModal(item)}>
                      {item.insuranceName}
                    </td>
                    <td className="pointer" onClick={() => handlePatientViewModal(item)}>
                      {item.numberOfVisits}
                    </td>
                    <td className="pointer" onClick={() => handlePatientViewModal(item)}>
                      ${item.totalPayment}
                    </td>
                    <td className="pointer" onClick={() => handlePatientViewModal(item)}>
                      ${item.averageRevPerVisit}
                    </td>
                    <td className="bulk hidden">
                      {item.id}
                    </td>
                    <td className="docpro_text_center">
                    <div className="docpro_icon_btns">
                        {buttonArray
                          .filter((_, index1) => permissions[`showButton${index1 + 1}`])
                          .slice(0, showButtonCount)
                          .map((btn, btnIndex) => (
                            <div key={btnIndex}>
                              {btn.isButton ? (
                                <button type="button" className="docpro_icon_btn" onClick={() => btn.action(item)}>
                                  <btn.icon width={18} height={18} />
                                  <span className="docpro_tip">{btn.label}</span>
                                </button>
                              ) : (
                                <Link to={`${btn.action}?patient_id=${item.id}`}>
                                  <button type="button" className="docpro_icon_btn">
                                    <btn.icon width={18} height={18} />
                                    <span className="docpro_tip">{btn.label}</span>
                                  </button>
                                </Link>
                              )}
                            </div>
                          ))
                        }
                        {(can_visit('waiting_room') && can_visit('waiting_room_create') && !can_visit('ehr_veradigm')) && (
                          <div className="dropdown-waiting-container" style={{ position: 'relative' }}>
                            <button className="docpro_icon_btn" onClick={() => handleWaitingDropdownClick(index)}>
                              <Armchair width={18} height={18} />
                              <span className="docpro_tip">Add to waiting room</span>
                            </button>
                            {viewWaitingProviderOptions[index] && (
                              <div className={`docpro_button_toggle_options ${index > 4 && 'top_position'}`}>
                                {userProviders?.length > 0 ? (
                                  userProviders?.map((provider, index2) => (
                                    <p key={index2} onClick={() => {handleAddToWaitingRoom(item, provider?.provider_id); setViewWaitingProviderOptions({})}}>{provider?.first_name}{' '}{provider?.last_name}</p>
                                  )
                                )) : (
                                  <p className="docpro_red_color" style={{ cursor: 'auto' }}>Providers not found</p>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                        {buttonArray?.length > showButtonCount &&
                          buttonArray.filter((_, index2) => permissions[`showButton${index2 + 1}`]).length > showButtonCount && (
                            <div className="dropdown-container relative">
                              <button className="docpro_icon_btn" onClick={() => handleDropdownClick(index)}>
                                <EllipsisVertical width={18} height={18} />
                              </button>
                              {viewStatusOptions[index] && (
                                <div className={`docpro_button_toggle_options ${index > 4 && 'top_position'}`}>
                                  {buttonArray
                                    .filter((_, index2) => permissions[`showButton${index2 + 1}`])
                                    .slice(showButtonCount)
                                    .map((btn, btnIndex) => (
                                      <div key={btnIndex}>
                                        {btn.isButton ? (
                                          <button
                                            type="button"
                                            className="docpro_icon_btn docpro_dropdown_button"
                                            onClick={() => btn.action(item)}
                                          >
                                            <btn.icon width={18} height={18} />
                                            <span>{btn.label}</span>
                                          </button>
                                        ) : (
                                          <Link to={`${btn.action}?patient_id=${item.id}`}>
                                            <button type="button" className="docpro_icon_btn docpro_dropdown_button">
                                              <btn.icon width={18} height={18} />
                                              <span>{btn.label}</span>
                                            </button>
                                          </Link>
                                        )}
                                      </div>
                                    ))}
                                </div>
                              )}
                            </div>
                          )
                        }
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan={`${can_visit("_role_enterprise") ? 13 : 11}`}>
                    No data available
                  </td>
                </tr>
              )
            ) : (
              Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} style={{ height: '50px' }}>
                  <td style={{ width: "45px" }}> <Skeleton width="1.2rem" borderRadius="8px"></Skeleton> </td>
                  {can_visit("_role_enterprise") && (
                    <>
                      <td> <Skeleton width={`${3 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                      <td> <Skeleton width={`${4 + (index % 1.2)}rem`} borderRadius="8px"></Skeleton> </td>
                    </>
                  )}
                  <td> <Skeleton width={`${5 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="5rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="3rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="6rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5.5 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${2 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 1.8)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${3 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td className="text-right"> <span className="mr-4 pr-2"><Skeleton width="3rem" borderRadius="8px"></Skeleton></span> </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {activeModal && (
        <MessageModal
          patient_id={patientData.id}
          last_name={patientData.lastName}
          first_name={patientData.firstName}
          phone={patientData.phoneNumber}
          messageTemplate={messageTemplate}
          tooltip={true}
          account_id={account_id}
          location_id={location_id}
          activeModal={activeModal}
          setActiveModal={setActiveModal}
          setSmsLimit={setSmsLimit}
          previousScrollPosition={previousScrollPosition}
        />
      )}

      {activeLetterModal && (
        <LetterModal
          last_name={patientData.lastName}
          first_name={patientData.firstName}
          address={patientData.address}
          messageTemplate={messageTemplate}
          account_id={account_id}
          location_id={location_id}
          activeModal={activeLetterModal}
          setActiveModal={setactiveLetterModal}
          setLetterLimit={setLetterLimit}
          previousScrollPosition={previousScrollPosition}
        />
      )}

      {activeCreateOrderModal && (
        <CreateOrderModal
          last_name={patientData.lastName}
          first_name={patientData.firstName}
          phone={patientData.phoneNumber}
          patient_id = {patientData.id}
          insurance_name = {patientData.insuranceName}
          insurance_code = { patientData.insurance_code}
          zip_code = { patientData.zip}
          user_id={user_id}
          account_id={account_id}
          location_id={location_id}
          activeModal={activeCreateOrderModal}
          setActiveModal={setActiveOrderModal}
          setSmsLimit={setSmsLimit}
          previousScrollPosition={previousScrollPosition}
        />
      )}

      {activePatientViewModal && (
        <PatientSingleViewModal
          practice_id={account_id}
          patient_id={patientData.id}
          reloadData={reloadData}
          reloadDataFilter={reloadDataFilter}
          messageTemplate={messageTemplate}
          account_id={account_id}
          location_id={location_id}
          insuranceOptions={insuranceOptions}
          activeModal={activePatientViewModal}
          setActiveModal={setActivePatientViewModal}
          setSmsLimit={setSmsLimit}
          outreachOpen={outreachOpen}
          setOutreachOpen={setOutreachOpen}
          startSchedular={startSchedular}
          setStartSchedular={setStartSchedular}
          callNoteCallType={callNoteCallType}
          setCallNoteCallType={setCallNoteCallType}
          setActiveCallNoteCallModal={setActiveCallNoteCallModal}
          callId={callId}
          previousScrollPosition={previousScrollPosition}
          setPreviousCallScrollPosition={setPreviousCallScrollPosition}
        />
      )}

      {activeCallNoteModal && (
        <CallNoteModal
          patient_data={patientData} 
          activeModal={activeCallNoteModal}
          setActiveModal={setActiveCallNoteModal}
          setCallNoteCallType={setCallNoteCallType}
          setActiveCallNoteCallModal={setActiveCallNoteCallModal}
          previousScrollPosition={previousScrollPosition}
          setPreviousCallScrollPosition={setPreviousCallScrollPosition}
        />
      )}

      {activeCallNoteCallModal && (
        <CallNoteCallModal
          account_id={account_id}
          location_id={location_id}
          patient_data={patientData}
          callNoteCallType={callNoteCallType}
          activeModal={activeCallNoteCallModal}
          setActiveModal={setActiveCallNoteCallModal}
          setOutreachOpen={setOutreachOpen}
          setActivePatientViewModal={setActivePatientViewModal}
          startSchedular={startSchedular}
          setStartSchedular={setStartSchedular}
          smsLimit={smsLimit}
          setCallId={setCallId}
          previousCallScrollPosition={previousCallScrollPosition}
        />
      )}
    </>
  );
}